import React from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import { useHistory } from 'react-router';
import { ErrorBoundaryInner } from './error-boundary-inner';

const ErrorBoundary: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<ErrorBoundaryProps>
>> = props => {
  const history = useHistory();
  const context = useAppContext();

  return (
    <ErrorBoundaryInner
      history={history}
      context={context}
      onError={props.onError}
    >
      {props.children}
    </ErrorBoundaryInner>
  );
};

interface ErrorBoundaryProps {
  onError: (error: any) => void | React.ReactNode;
  children: React.ReactNode;
}

export default ErrorBoundary;
